import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import { LittleForm } from "components/Custom/LittleForm";

/**
 * Analyse component to display the analysis of a conversation.
 * @param {Object} conversation - The conversation object containing analysis data.
 * @param {Object} resource - The resource configuration.
 * @param {Object} dictionary - The dictionary data for the conversation.
 * @param {Object} dictionarySkeleton - The skeleton structure for the dictionary.
 * @return {JSX.Element} The rendered Analyse component.
 */
const Analyse = ({ conversation, resource, dictionary, dictionarySkeleton }) => {
	return (
		<MDBox>
			{!lod_.isEmpty(dictionary) && !lod_.isEmpty(dictionarySkeleton) && (
				<LittleForm
					disabled
					object={dictionary?.items}
					metadatasSkeleton={dictionarySkeleton}
					handleChange={(path, value) => {}}
				/>
			)}
		</MDBox>
	);
};

export default Analyse;
